import * as React from 'react';

import { MapController } from './MapController';

export const MapControllerContext = React.createContext<MapController | null>(null);

interface IMapControllerProviderProps {
  controller: MapController;
  children: React.ReactNode;
}

export function MapControllerProvider({ controller, children }: IMapControllerProviderProps) {
  return <MapControllerContext.Provider value={controller}>{children}</MapControllerContext.Provider>;
}
